module.exports = __webpack_public_path__ + "img/1-lace-front-full-lace-wigs.5a20b227.jpg";